
const tz = 'America/El_Salvador';

// Formato simple: YYYY-MM-DD (Usando El Salvador Timezone)
export const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return new Intl.DateTimeFormat('en-CA', { 
    timeZone: tz, 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  }).format(d);
};

// Formato más legible: DD/MM/YYYY (Usando El Salvador Timezone)
export const formatDateReadable = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return new Intl.DateTimeFormat('en-GB', { 
    timeZone: tz, 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  }).format(d);
};

// Ejemplo con hora: DD/MM/YYYY HH:mm (Usando El Salvador Timezone)
export const formatDateTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const dateStr = new Intl.DateTimeFormat('en-GB', { 
    timeZone: tz, 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  }).format(d);
  
  const timeStr = new Intl.DateTimeFormat('en-GB', { 
    timeZone: tz, 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false
  }).format(d);

  return `${dateStr} ${timeStr}`;
};
